import styled from 'styled-components';

export const HRC = styled.div`
  ol, ul, li {
    all: revert;
  }
`;
